<template>
  <div class="app">
    <div class="title">
      <div
        style="display: flex;justify-content: space-between;padding-right: 2%;height: 6vh;align-items: center; font-size: 0.8vw;">
        <div class="logo">
          <!-- <img src="./assets/Blogo.png" alt=""> -->
          <!-- <img src="./assets/jinbaite.png" alt=""> -->
          <!-- <span>中央厨房后台管理系统</span> -->
          <img src="./assets/anhuilogo.png" alt="">
          <span>智慧后厨管理系统</span>
        </div>

        <div>
          <div class="header-right">
            <!-- 为dropdown添加ref，用于手动控制关闭 -->
            <el-dropdown trigger="click" placement="bottom-end" ref="userDropdown">
              <span class="user-info">
                <span class="user-name">管理员</span>
                <i class="el-icon-arrow-down"></i>
              </span>

              <el-dropdown-menu class="custom-dropdown-menu">
                <div class="custom-dropdown-item" @click="openChangePwdDialog">
                  修改密码
                </div>
                <div class="custom-dropdown-item" @click="back">
                  退出登录
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <Sidebar @update-collapse="handleUpdateCollapse"></Sidebar>

      <el-col :span="columnSpan">
        <router-view />
      </el-col>
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="isEdits"
      style="height: 100vh;background:rgba(0, 0, 0, 0.5); width: 100%;position: fixed;top: 0;z-index: 999;">
      <div class="edits">
        <div class="edit_title">
          <p>修改密码</p>
          <p @click="cancellation">X</p>
        </div>
        <el-form :model="pwdForm" ref="pwdFormRef" :rules="pwdRules" label-width="120px" class="demo-user"
          :disabled="isSubmitting">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input style="width: 75%;" v-model="pwdForm.oldPassword" type="password" placeholder="请输入当前密码"
              :disabled="isSubmitting"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input style="width: 75%;" v-model="pwdForm.newPassword" type="password" placeholder="请输入6-20位新密码"
              :disabled="isSubmitting"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input style="width: 75%;" v-model="pwdForm.confirmPassword" type="password" placeholder="请再次输入新密码"
              :disabled="isSubmitting"></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 60px; display: flex; align-items: center; gap: 10px;">
            <el-button type="primary" @click="submitChangePwd" :loading="isSubmitting">提交</el-button>
            <el-button @click="cancellation" :disabled="isSubmitting">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/SlideMenu.vue'
import { updatePassword } from "@/api/personnel";

export default {
  components: { Sidebar },
  data() {
    return {
      isCollapse: true,
      isEdits: false,
      isSubmitting: false,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 20, message: '旧密码长度需在6-20字符之间', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '新密码长度需在6-20字符之间', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && this.pwdForm.oldPassword && value === this.pwdForm.oldPassword) {
                callback(new Error('新密码不能与旧密码相同'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.newPassword) {
                callback(new Error('两次输入的新密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },

  methods: {
    // 退出登录：添加关闭下拉菜单逻辑
    back() {
      // 1. 手动关闭下拉菜单（Element UI提供的方法）
      this.$refs.userDropdown.hide();

      // 2. 执行退出登录逻辑
      localStorage.removeItem('userId');
      this.$router.push("/");

      // 3. 确保修改密码弹窗也关闭（如果打开的话）
      this.isEdits = false;
    },

    openChangePwdDialog() {
      this.isEdits = true;
      this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
      this.$nextTick(() => {
        this.$refs.pwdFormRef?.clearValidate();
      });
      // 关闭下拉菜单
      this.$refs.userDropdown.hide();
    },

    cancellation() {
      this.isEdits = false;
      this.isSubmitting = false;
    },

    handleUpdateCollapse(isCollapse) {
      this.isCollapse = isCollapse;
    },

    submitChangePwd() {
      this.$refs.pwdFormRef.validate((valid) => {
        if (!valid) return;

        this.isSubmitting = true;
        const pwdParams = {
          userId: localStorage.getItem('userId'),
          password: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        };

        updatePassword(pwdParams)
          .then((response) => {
            if (response.success || response.code === 200) {
              this.$message.success('密码修改成功！请重新登录');
              this.cancellation();
              this.$router.push("/login");
              localStorage.removeItem('token');
            } else {
              this.$message.error(response.message || '密码修改失败');
            }
          })
          .catch((error) => {
            console.error('修改密码异常：', error);
            this.$message.error('网络异常，请重试');
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      });
    }
  },

  computed: {
    columnSpan() {
      return this.$route.name === 'logo' ? 24 : (this.isCollapse ? 23 : 21);
    }
  }
}
</script>

<style lang="scss">
/* 原有样式保持不变 */
ul,
li {
  list-style: none;
  padding: 0;
}

.el-menu-item {
  min-width: 10px !important;
}

.app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.demo-user {
  margin-top: 40px;
  padding: 0 20px;
}

.title {
  width: 100%;
  height: 6vh;
  color: #fff;
  background: rgb(250, 129, 45);
  //background: #409eff;
  position: fixed;
  z-index: 999;

  .logo {
    margin-left: 1%;

    img {
      width: 4vw;
      height: 4vh;
      margin-right: 10px;
    }
  }

  img {
    width: 1.5vw;
    height: 3vh;
  }
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
  color: #fff;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }
}

.user-name {
  margin-right: 5px;
}

.el-menu-vertical-demo {
  height: 94vh;
}

.edits {
  width: 450px;
  height: 380px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .edit_title {
    display: flex;
    justify-content: space-between;
    background-color: rgb(51, 119, 255);
    color: #fff;
    height: 45px;
    align-items: center;
    padding: 0 20px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-size: 16px;

    p:last-child {
      cursor: pointer;
      font-size: 18px;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}

@media (max-width: 768px) {
  .edits {
    width: 90%;
    height: auto;
    padding-bottom: 20px;
  }

  .demo-user {
    margin-top: 30px;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .el-form-item:last-child {
    margin-left: 0 !important;
    text-align: center;
  }
}

.custom-dropdown-menu {
  min-width: 120px;
  padding: 5px 0;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid #e4e7ed;
}

.custom-dropdown-item {
  display: block;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f7fa;
    color: #409eff;
  }

  &:active {
    background-color: #e8f0fe;
  }
}
</style>
